// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3460":"39b5879e8cca0320","7269":"313da560ea3ae0a3"}[chunkId] + ".css";
};